import styles from './sass/LaunchpadHubLoading.module.scss';

const LANE_COUNT = 5;

function LaunchpadHubLoading() {
  return (
    <div className={styles.root} aria-hidden="true">
      {Array.from({ length: LANE_COUNT }).map((_, index) => (
        <div key={`launchpad-lane-skeleton-${index + 1}`} className={styles.lane}>
          <div className={styles.label} />
          <div className={styles.tiles}>
            {Array.from({ length: 3 }).map((__, tileIndex) => (
              <div key={`launchpad-tile-skeleton-${tileIndex + 1}`} className={styles.tile} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default LaunchpadHubLoading;
